import { create } from 'zustand';

interface ActivityState {
  activityCount: number;
  pushPermissionGranted: boolean;
  pendingPushRoute: string | null;
  setActivityCount: (count: number) => void;
  setPushPermissionGranted: (granted: boolean) => void;
  setPendingPushRoute: (url: string | null) => void;
}

export const useActivityStore = create<ActivityState>((set) => ({
  activityCount: 0,
  pushPermissionGranted: false,
  pendingPushRoute: null,
  setActivityCount: (activityCount) => set({ activityCount }),
  setPushPermissionGranted: (pushPermissionGranted) => set({ pushPermissionGranted }),
  setPendingPushRoute: (pendingPushRoute) => set({ pendingPushRoute }),
}));
